<app-page-template
  [showParent]="showParent"
  (clearQueryString)="onClearQueryString()"
  [config]="pageConfig"
  (sortObject)="getSortItems($event)"
  (comparisonObjects)="getComparisonObjects($event)"
  (pageNumber)="changePageNumber($event)"
  (pageSize)="changePageSize($event)"
  (onRefresh)="onReset()"
  (onShowHelpPage)="onShowHelpPage()"
>
  <!--------------------------------------- Header Btns --------------------------------------->

  <div class="card-toolbar" custom-elements>
    <!-- refresh btn -->
    <a
      class="btn btn-light txt-lg button-shadow tw-mx-1 text-blue btn-hover-rise"
      mat-ripple
      [matTooltip]="'common.refresh' | translate"
      (click)="onReset()"
    >
      <i class="mdi mdi-refresh mdi-20px tw-p-0 text-blue"></i>
    </a>

    <!-- back btn -->
    <a
      class="btn btn-light txt-lg button-shadow tw-mx-1 btn-hover-rise"
      mat-ripple
      [matTooltip]="'common.back' | translate"
      (click)="onClose()"
    >
      <i class="mdi mdi-arrow-left mdi-20px tw-p-0"></i>
    </a>
  </div>

  <!--------------------------------------- Table Content --------------------------------------->
  <ng-container table-body *ngIf="(items$ | async) && !pageConfig.loading">
    <ng-container *ngFor="let item of items$ | async; let i = index">
      <tr
        #row
        (click)="onActiveRow(row, i)"
        [class.row-active]="rowIndexSelected == i"
      >
        <!-- index -->
        <td class="tw-text-center !tw-px-4 !tw-py-2">
          {{ paginationModel?.firstIndex + i }}
        </td>

        <!-- createdBy -->
        <td class="tw-py-2">
          <td-value
            class="tw-font-medium"
            copyToClipboard
            [value]="item?.createdBy"
          ></td-value>
        </td>

        <!-- scheduledMessageId -->
        <td class="tw-py-2">
          <td-value
            class="tw-font-medium"
            copyToClipboard
            [value]="item?.scheduledMessageId"
          ></td-value>
        </td>

        <!-- newScheduledMessageId -->
        <td class="tw-py-2">
          <td-value
            class="tw-font-medium"
            copyToClipboard
            [value]="item?.newScheduledMessageId"
          ></td-value>
        </td>

        <!-- deliveryStatuses -->
        <td class="msg-summary tw-text-center tw-cursor-pointer tw-py-1">
          <app-expand-text-click
            [smallText]="item?.deliveryStatusesNames | join : ', '"
            [placement]="'right'"
            data-toggle="tooltip"
          >
            <span small-text>{{
              item?.deliveryStatusesNames | join : ", "
            }}</span>
            <ng-container full-text>{{
              item?.deliveryStatusesNames | join : ", "
            }}</ng-container>
          </app-expand-text-click>
        </td>

        <!-- created -->
        <td class="tw-py-4">
          <td-value
            copyToClipboard
            type="dateTimeWithSecond"
            [value]="item?.created"
          ></td-value>
        </td>
      </tr>
    </ng-container>
  </ng-container>
</app-page-template>
